const CalculateTotalPrice = (cart, cyod) => {
  let totalPrice = 0;

  if (Object.keys(cyod.selectedProducts).length > 0) {
    Object.values(cyod.selectedProducts).forEach((selectedProduct) => {
      const product = selectedProduct.product;
      totalPrice += Number(product.price) / 1.21;

      selectedProduct?.accessories?.forEach((item: any) => {
        totalPrice += Number(item.accessory.sale_price) / 1.21;
      });
    });
  }

  totalPrice += Number(cart.totalPrice);
  const finalPrice = Math.abs(totalPrice).toFixed(2);

  return Number(finalPrice);
};

export default CalculateTotalPrice;
